import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './initUsedBytesInfo.json';

const initUsedBytesInfo = (req, res, ctx) => {
  return res(
    ctx.json(mockResponse(apiResponses['usedbytesSearchController/initUsedBytesInfo'].success[req.body.path]))
  );
};

export const handlers = [
  rest.post(
    getApiEndpoint('usedbytesSearchController/initUsedBytesInfo'),
    withScenario(withAuthCheck(initUsedBytesInfo))
  ),
];
